module.exports = __webpack_public_path__ + "static/media/basketweave-leatherworking-tool.2bb1a275.webp";